import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "@semo/icons";
import { useNavigate } from "react-router-dom";
import { Button } from "../primitives/button";

const MotionButton = motion.create(Button);

export interface BackToHomeButtonProps {
  to?: string;
  label?: string;
}

/**
 * Fixed positioned button to navigate back to home page
 */
export const BackToHomeButton = React.memo(
  ({ to = "/", label = "홈으로" }: BackToHomeButtonProps) => {
    const navigate = useNavigate();

    return (
      <MotionButton
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        onClick={() => navigate(to)}
        variant="outline"
        className="fixed top-4 left-4 md:top-8 md:left-8 z-50 rounded-full border-border bg-background/80 backdrop-blur-sm text-muted-foreground hover:text-primary shadow-sm hover:shadow-md active:scale-95 h-auto py-2 px-4 md:py-2.5 md:px-5 gap-1.5 md:gap-2"
        aria-label={`${label} 이동`}
      >
        <ArrowLeft className="w-3.5 h-3.5 md:w-4 md:h-4" />
        <span className="text-xs md:text-sm font-semibold">{label}</span>
      </MotionButton>
    );
  },
);

BackToHomeButton.displayName = "BackToHomeButton";
